'use client'

import { useState, useEffect } from 'react'
import Image from 'next/image'

export default function PartnersCarousel() {
  const [currentSlide, setCurrentSlide] = useState(0)

  const partners = [
    [
      { name: 'D+ Saúde', logo: '/image/logo.svg', width: 124, height: 58 },
      { name: 'SEG Clin', logo: '/image/home/segClin.png', width: 234, height: 64 },
      { name: 'Casmed', logo: '/image/home/casmed.png', width: 124, height: 65 }
    ],
    [
      { name: 'Mednet', logo: '/image/home/mednet.png', width: 143, height: 38 },
      { name: 'ControlMed', logo: '/image/home/controlMed.png', width: 101, height: 30 },
      { name: 'DortPrev', logo: '/image/home/dortPrev.png', width: 201, height: 62 }
    ],
    [
      { name: 'Grupo Master', logo: '/image/home/grupoMaster.png', width: 124, height: 58 },
      { name: 'Mais Saúde', logo: '/image/home/maisSaude.png', width: 182, height: 65 }
    ]
  ]

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % partners.length)
    }, 4000)

    return () => clearInterval(timer)
  }, [partners.length])

  return (
    <div className="relative w-full max-w-6xl mx-auto">
      <div className="overflow-hidden rounded-lg">
        <div
          className="flex transition-transform duration-700 ease-in-out"
          style={{ transform: `translateX(-${currentSlide * 100}%)` }}
        >
          {partners.map((slide, slideIndex) => (
            <div key={slideIndex} className="w-full flex-shrink-0">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-8 p-8 items-center justify-center">
                {slide.map((partner, partnerIndex) => (
                  <div 
                    key={partnerIndex} 
                    className="flex items-center justify-center p-4"
                  >
                    <Image 
                      src={partner.logo} 
                      alt={partner.name}
                      width={partner.width}
                      height={partner.height}
                      className="object-contain max-w-full h-auto opacity-80 hover:opacity-100 transition-opacity"
                    />
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Indicators */}
      <div className="flex justify-center space-x-2 mt-6">
        {partners.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentSlide(index)}
            className={`w-3 h-3 rounded-full transition-colors ${
              index === currentSlide ? 'bg-green-600' : 'bg-gray-300'
            }`}
            aria-label={`Ir para slide ${index + 1}`}
          />
        ))}
      </div>
    </div>
  )
}

